<!--
Copyright 2022 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license, please see LICENSE.md in the
project root for license information or contact permission@sei.cmu.edu for full terms.
-->

<crucible-dialog
  [dialogTitle]="data.title"
  [submitDisabled]="!errorFree()"
  [guardUnsavedWork]="true"
  (cancel)="handleEditComplete(false)"
  (submit)="handleEditComplete(true)"
>
<div crucibleDialogContent>
  @if (!data.dataField.isTemplate) {
  <div class="data-field-detail" (click)="$event.stopPropagation();">
    <div class="single-detail">
      <mat-form-field class="full-width">
        <mat-label>Display Order</mat-label>
        <input type="text" matInput [(ngModel)]="data.dataField.displayOrder"
          [disabled]="!data.canEdit && !data.isOwner" />
      </mat-form-field>
    </div>
  </div>
  }
  <div class="data-field-detail" (click)="$event.stopPropagation();">
    <div class="single-detail">
      <mat-form-field class="full-width">
        <mat-label>Name</mat-label>
        <input type="text" matInput [(ngModel)]="data.dataField.name" [disabled]="!data.canEdit && !data.isOwner" />
      </mat-form-field>
    </div>
  </div>
  <div class="data-field-detail" (click)="$event.stopPropagation();">
    <div class="single-detail">
      <mat-form-field class="full-width">
        <mat-label>Data Type</mat-label>
        <mat-select [value]="data.dataField.dataType" (selectionChange)="changeDataFieldDataType($event.value)"
          [disabled]="!data.canEdit && !data.isOwner">
          @for (dataFieldType of (data.dataFieldTypes | keyvalue); track dataFieldType) {
          <mat-option value="{{ dataFieldType.key }}">{{ dataFieldType.key }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <div class="data-field-detail" (click)="$event.stopPropagation();">
    <div class="single-detail">
      <div class="partial-detail">
        <div>
          <mat-checkbox [(ngModel)]="data.dataField.isChosenFromList"
            [disabled]="(!data.canEdit && !data.isOwner) || optionListNotAllowed() || isCompetency()" class="bottom-margin">
            Use Option List
          </mat-checkbox>
          @if (data.dataField.isChosenFromList && !optionListNotAllowed()) {
          <span class="options-link clickable" (click)="viewAllOptions()"
            title="Click to manage options">
            @if (isCompetency()) {
            {{ data.dataField.dataOptions.length > 0 ? data.dataField.dataOptions.length + ' competencies' : 'Manage' }}
            } @else {
            {{ data.dataField.dataOptions.length }} options
            }
          </span>
          }
        </div>
        @if (data.dataField.isChosenFromList) {
        <div>
          <mat-checkbox [(ngModel)]="data.dataField.isMultiSelect"
            [disabled]="(!data.canEdit && !data.isOwner) || optionListNotAllowed() || isCompetency()" class="bottom-margin left-margin">
            Multi-select
          </mat-checkbox>
        </div>
        }
      </div>
    </div>
  </div>
  @if (!data.dataField.isTemplate) {
  <div class="data-field-detail" (click)="$event.stopPropagation();">
    <div class="single-detail">
      <mat-checkbox [(ngModel)]="data.dataField.onScenarioEventList" [disabled]="!data.canEdit && !data.isOwner"
        class="bottom-margin">Display on the Events
        list</mat-checkbox><br />
    </div>
  </div>
  }
  @if (!data.dataField.isTemplate) {
  <div class="data-field-detail" (click)="$event.stopPropagation();">
    <div class="single-detail">
      <mat-checkbox [(ngModel)]="data.dataField.onExerciseView" [disabled]="!data.canEdit && !data.isOwner"
        class="bottom-margin">Display on the Exercise View</mat-checkbox><br />
    </div>
  </div>
  }
  @if (!data.dataField.isTemplate) {
  <div class="data-field-detail" (click)="$event.stopPropagation();">
    <div class="single-detail">
      <mat-checkbox [(ngModel)]="data.dataField.isInformationField" [disabled]="!data.canEdit && !data.isOwner"
        class="bottom-margin">Information Data
        Field</mat-checkbox><br />
    </div>
  </div>
  <div class="data-field-detail" (click)="$event.stopPropagation();">
    <div class="single-detail">
      <mat-checkbox [(ngModel)]="data.dataField.isFacilitationField" [disabled]="!data.canEdit && !data.isOwner"
        class="bottom-margin">Facilitation Data
        Field</mat-checkbox><br />
    </div>
  </div>
  <div class="data-field-detail" (click)="$event.stopPropagation();">
    <div class="single-detail">
      <mat-checkbox [(ngModel)]="data.dataField.isShownOnDefaultTab" [disabled]="!data.canEdit && !data.isOwner"
        class="bottom-margin">Display on "Default" edit
        tab</mat-checkbox><br />
    </div>
  </div>
  <div class="data-field-detail" (click)="$event.stopPropagation();">
    <div class="single-detail">
      <mat-checkbox [(ngModel)]="data.dataField.isAssessorVisible" [disabled]="!data.canEdit && !data.isOwner"
        class="bottom-margin">Assessor View</mat-checkbox><br />
    </div>
  </div>
  }
  @if (!data.dataField.isTemplate) {
  <div class="data-field-detail" (click)="$event.stopPropagation();">
    <div class="single-detail">
      <mat-checkbox [(ngModel)]="data.dataField.isOnlyShownToOwners" [disabled]="!data.canEdit && !data.isOwner"
        class="bottom-margin">Display for Content Developers and
        MSEL Owners ONLY !!!</mat-checkbox><br />
    </div>
  </div>
  }
  @if (data.useGallery) {
  <div class="data-field-detail" (click)="$event.stopPropagation();">
    <div class="single-detail">
      <mat-form-field class="full-width">
        <mat-label>Gallery Article Parameter</mat-label>
        <mat-select [(ngModel)]="data.dataField.galleryArticleParameter" [disabled]="!data.canEdit && !data.isOwner">
          <mat-option value=""></mat-option>
          @for (parameter of data.galleryArticleParameters; track parameter) {
          <mat-option value="{{ parameter }}">{{ parameter }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  }
  @if ((data.canEdit || data.isOwner) && !data.dataField.isTemplate) {
  <div class="data-field-detail" (click)="$event.stopPropagation();">
    <div class="single-detail">
      <mat-form-field class="full-width">
        <mat-label>Column Metadata (Width)</mat-label>
        <input type="text" matInput [(ngModel)]="data.dataField.columnMetadata" />
      </mat-form-field>
    </div>
  </div>
  }
  @if ((data.canEdit || data.isOwner) && !data.dataField.isTemplate) {
  <div class="data-field-detail" (click)="$event.stopPropagation();">
    <div class="single-detail">
      <mat-form-field class="full-width">
        <mat-label>Cell Metadata (Color, Tint, Font-Weight)</mat-label>
        <input type="text" matInput [(ngModel)]="data.dataField.cellMetadata" />
      </mat-form-field>
    </div>
  </div>
  }
</div>
</crucible-dialog>
